import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Input, notification } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import _auth from '@netuno/auth-client';
import _service from '@netuno/service-client';

import './index.less';

const langContext = 'login.recover';

export default function RecoverModal(props) {

    const [submitting, setSubmitting] = useState(false);
    const [visible, setVisible] = useState(true);
    const recoverForm = useRef(null);

    useEffect(() => {
        if (_auth.isLogged()) {
            window.scrollTo(0, 0)
        }
        window.scrollTo(0, 0)
    });

    function onFinish(values) {
        setSubmitting(true);
        const { mail } = values;
        _service({
            method: 'PUT',
            url: 'recovery',
            data: {
                mail,
            },
            success: (response) => {
                if (response.json.result) {
                    notification["success"]({
                        message: 'Alteração da Palavra-Passe ',
                        description: 'Foi enviado um e-mail para a alteração da Palavra-Passe.',
                    });
                    setSubmitting(false);
                    setVisible(false);
                }
            },
            fail: () => {
                setSubmitting(false);
                notification["error"]({
                    message: 'Erro na Alteração da Palavra-Passe',
                    description: 'Não foi possível alterar a palavra-passe, contacte-nos através do chat de suporte.',
                });
            }
        });
    }

    const intl = useIntl();

    function onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
    }

    function onSubmit() {
        recoverForm.current.validateFields()
            .then(values => {
                recoverForm.current.resetFields();
                onFinish(values);
            })
            .catch(info => {
                console.log('Validate Failed:', info);
            });
    }

    function onCancel() {
        setVisible(false);
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <Modal
            className={'modal-recover'}
            title={intl.formatMessage({ id: langContext + '.title' })}
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onCancel}>
                    <FormattedMessage id={`${langContext}.button.cancel`} />
                </Button>,
                <Button key="send" type="primary" htmlType="submit" loading={submitting} onClick={onSubmit} >
                    <FormattedMessage id={`${langContext}.button.send`} />
                </Button>
            ]}
        >
            <Form
                ref={recoverForm}
                name="basic"
                onFinishFailed={onFinishFailed}
            >
                <Form.Item
                    label={intl.formatMessage({ id: langContext + '.email' })}
                    name="mail"
                    rules={[
                        { type: 'email', message: 'O e-mail inserido não é válido.' },
                        { required: true, message: 'Insira o e-mail.' }
                    ]}
                >
                    <Input disabled={submitting} maxLength={250} />
                </Form.Item>
            </Form>

        </Modal>
    );

}